import { useState, useEffect } from 'react';

const useTimer = (startTime: number, type?: string) => {
  const [time, setTime] = useState(startTime);
  const [intervalID, setIntervalID] = useState(null);
  const hasTimerEnded = +time <= 0;

  const update = () => {
    setTime(time => time - 1);
  };

  const startTimer = () => {
    setIntervalID(setInterval(update, 1000));
  };

  const stopTimer = () => {
    clearInterval(intervalID);
    setIntervalID(null);
  };

  const resetTimer = () => {
    setTime(startTime);
    startTimer();
  };

  useEffect(() => {
    if (hasTimerEnded) {
      clearInterval(intervalID);
      setIntervalID(null);
    }
  }, [hasTimerEnded]);

  useEffect(
    () => () => {
      clearInterval(intervalID);
    },
    []
  );

  return {
    time: type ? time : time >= 10 ? time : '0' + time,
    startTimer,
    resetTimer,
    stopTimer
  };
};

export { useTimer };
